import { render, staticRenderFns } from "./ContractComments.vue?vue&type=template&id=4f7d1faa&scoped=true"
import script from "./ContractComments.vue?vue&type=script&lang=js"
export * from "./ContractComments.vue?vue&type=script&lang=js"
import style0 from "./ContractComments.vue?vue&type=style&index=0&id=4f7d1faa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7d1faa",
  null
  
)

export default component.exports